import React from 'react'
import StudentDash from '../../Components/StudentComponents/StudentDash/StudentDash'
import FeedbackForm from '../../Components/Feedback/FeedbackForm'

function FeedbackPageS() {
  return (
    <StudentDash>
        <FeedbackForm/>
    </StudentDash>
  )
}

export default FeedbackPageS